<script>
export default {
  // ========== props ==========
  props: {
    inputValue: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    minLimit: {
      type: Number,
      default: 0,
    },
    maxLimit: {
      type: Number,
      default: 100,
    },
    unit: {
      type: String,
      default: '',
    },
  },

  // ========== data ==========
  data() {
    return {
        value: this.inputValue,           // 真の値（数値）
        textValue: String(this.inputValue), // 入力中の表示（文字列）
      _numInputEl: null,
      _onNumInput: null,
    }
  },

  mounted() {
    this.$nextTick(() => {
      const el = this.$el.querySelector('.el-slider__input input')
        || this.$el.querySelector('.el-input-number input')
        || this.$el.querySelector('input.el-input__inner')

      if (!el) return

      el.setAttribute('inputmode', 'numeric')
      el.setAttribute('pattern', '[+-]?[0-9]*')

      this._numInputEl = el
      this._onNumInput = (e) => {
        const raw = String(e.target.value ?? '')
        const filtered = this._filterSignedInt(raw)
        if (raw !== filtered) e.target.value = filtered

        if (filtered === '' || filtered === '+' || filtered === '-') return

        const n = parseInt(filtered, 10)
        if (!Number.isFinite(n)) return

        // 入力中も範囲内にクランプして、表示も追従させる
        const min = Math.min(this.minLimit, this.maxLimit)
        const max = Math.max(this.minLimit, this.maxLimit)
        const v = Math.min(max, Math.max(min, n))

        if (this.value !== v) this.value = v
        // 例えば 5000000 と打っても即座に 5 に戻す
        if (String(e.target.value) !== String(v)) e.target.value = String(v)
    }

      el.addEventListener('input', this._onNumInput)
      el.addEventListener('paste', this._onNumInput)
    })
  },

  beforeDestroy() {
    if (this._numInputEl && this._onNumInput) {
      this._numInputEl.removeEventListener('input', this._onNumInput)
      this._numInputEl.removeEventListener('paste', this._onNumInput)
    }
    this._numInputEl = null
    this._onNumInput = null
  },


  // ========== watch ==========
  watch: {
      inputValue: {
          handler(val) {
                if (this.value !== val) this.value = val
                const s = String(val)
                if (this.textValue !== s) this.textValue = s
          },
          immediate: true
      },

        value: {
            handler(val) {
                const sanitized = this._sanitizeForEmit(val)
                if (!sanitized.ok) return
                // value が変わったらテキスト表示も追従
                const s = String(sanitized.value)
                if (this.textValue !== s) this.textValue = s

                if (this.inputValue !== sanitized.value) {
                    this.$emit('update:inputValue', sanitized.value)
      }
            },
            immediate: false
        }
    },

    methods: {
        _filterSignedInt(s) {
            const str = String(s)
            const sign = str[0] === '+' || str[0] === '-' ? str[0] : ''
            const digits = str.replace(/[+-]/g, '').replace(/\D/g, '')
            return sign + digits
        },

        _sanitizeForEmit(val) {
            // 親へは「確定した整数」だけ流す
            if (val === '' || val === '+' || val === '-') return { ok: false, value: this.inputValue }
            const n = typeof val === 'number' ? val : parseInt(String(val), 10)
            if (!Number.isFinite(n)) return { ok: false, value: this.inputValue }
            const v = Math.min(this.maxLimit, Math.max(this.minLimit, n))
            return { ok: true, value: v }
        },

        commitText() {
            const s = this.textValue

            // 空なら min に補完
            if (s === '' || s == null) {
                this.value = this.minLimit
                this.textValue = String(this.minLimit)
                return
            }

            // 数値化（ダメなら現在値に戻す）
            const n = Number(s)
            if (Number.isNaN(n)) {
                this.textValue = String(this.value)
                return
            }

            // min/max にクランプして確定
            const clamped = Math.min(this.maxLimit, Math.max(this.minLimit, n))
            this.value = clamped
            this.textValue = String(clamped)
        },

        onTextInput(v) {
            // 入力中はそのまま保持（空も許す）
            this.textValue = v
    }
  }
}
</script>

<template>
    <el-form-item :label="label" class="slot-wrap">
        <el-slider
            v-model="value"
            :disabled="disable"
            :min="minLimit"
            :max="maxLimit"
            :class="unit ? 'range-slider' : 'range-slider-full'"
        />

        <!-- 内蔵 input-number の代わりに自前入力欄 -->
        <el-input
            class="slider-input"
            :disabled="disable"
            :value="textValue"
            @input="onTextInput"
            @blur="commitText"
            @keyup.enter.native="commitText"
        />

      <span class="unit">{{ unit }}</span>
    </el-form-item>
</template>

<style scoped>
:deep(.el-form-item__content) {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: nowrap;
    min-width: 0;
}

.range-slider-full,
.range-slider {
    flex: 1 1 auto;
    min-width: 0;
}

/* 追加：入力欄幅を show-input 相当に */
.slider-input {
    flex: 0 0 120px;
}

.unit {
    flex: 0 0 50px;
    white-space: nowrap;
    text-align: right;
}
</style>
